export const allSelectConf = {
  //头条(巨量引擎)
  1: [
    { label: "dbt_aid", value: "__AID__" },
    { label: "dbt_aid_name", value: "__AID_NAME__" },
    { label: "dbt_advertiser_id", value: "__ADVERTISER_ID__" },
    { label: "dbt_cid", value: "__CID__" },
    { label: "dbt_cid_name", value: "__CID_NAME__" },
    { label: "dbt_campaign_id", value: "__CAMPAIGN_ID__" },
    { label: "dbt_campaign_name", value: "__CAMPAIGN_NAME__" },
    { label: "dbt_ctype", value: "__CTYPE__" },
    { label: "dbt_csite", value: "__CSITE__" },
    { label: "dbt_convert", value: "__CONVERT_ID__" },
    { label: "dbt_request_id", value: "__REQUEST_ID__" },
    { label: "dbt_sl", value: "__SL__" },
    { label: "dbt_imei", value: "__IMEI__" },
    { label: "dbt_idfa", value: "__IDFA__" },
    { label: "dbt_idfa_md5", value: "__IDFA_MD5__" },
    { label: "dbt_androidid", value: "__ANDROIDID__" },
    { label: "dbt_oaid", value: "__OAID__" },
    { label: "dbt_oaid_md5", value: "__OAID_MD5__" },
    { label: "dbt_os", value: "__OS__" },
    { label: "dbt_mac", value: "__MAC__" },
    { label: "dbt_mac1", value: "__MAC1__" },
    { label: "dbt_ip", value: "__IP__" },
    { label: "dbt_ua", value: "__UA__" },
    { label: "dbt_geo", value: "__GEO__" },
    { label: "dbt_ts", value: "__TS__" },
    { label: "dbt_callback_param", value: "__CALLBACK_PARAM__" },
    { label: "dbt_callback_url", value: "__CALLBACK_URL__" },
    { label: "dbt_model", value: "__MODEL__" },
    { label: "dbt_union_site", value: "__UNION_SITE__" },
    { label: "dbt_caid1", value: "__CAID1__" },
    { label: "dbt_caid1_md5", value: "__CAID1_MD5__" },
  ],
  //广点通（腾讯广告）
  2: [
    { label: "click_id", value: "__CLICK_ID__" },
    { label: "click_time", value: "__CLICK_TIME__" },
    { label: "impression_time", value: "__IMPRESSION_TIME__" },
    { label: "campaign_id", value: "__CAMPAIGN_ID__" },
    { label: "adgroup_id", value: "__ADGROUP_ID__" },
    { label: "ad_id", value: "__AD_ID__" },
    { label: "ad_platform_type", value: "__AD_PLATFORM_TYPE__" },
    { label: "ad_type", value: "__AD_TYPE__" },
    { label: "account_id", value: "__ACCOUNT_ID__" },
    { label: "agency_id", value: "__AGENCY_ID__" },
    { label: "click_sku_id", value: "__CLICK_SKU_ID__" },
    { label: "billing_event", value: "__BILLING_EVENT__" },
    { label: "deeplink_url", value: "__DEEPLINK_URL__" },
    { label: "universal_link", value: "__UNIVERSAL_LINK__" },
    { label: "page_url", value: "__PAGE_URL__" },
    { label: "device_os_type", value: "__DEVICE_OS_TYPE__" },
    { label: "process_time", value: "__PROCESS_TIME__" },
    { label: "promoted_object_id", value: "__PROMOTED_OBJECT_ID__" },
    { label: "promoted_object_type", value: "__PROMOTED_OBJECT_TYPE__" },
    { label: "real_cost", value: "__REAL_COST__" },
    { label: "request_id", value: "__REQUEST_ID__" },
    { label: "impression_id", value: "__IMPRESSION_ID__" },
    { label: "site_set", value: "__SITE_SET__" },
    { label: "muid", value: "__MUID__" },
    { label: "hash_android_id", value: "__HASH_ANDROID_ID__" },
    { label: "ip", value: "__IP__" },
    { label: "user_agent", value: "__USER_AGENT__" },
    { label: "callback", value: "__CALLBACK__" },
    { label: "encrypted_position_id", value: "__ENCRYPTED_POSITION_ID__" },
    { label: "ipv6", value: "__IPV6__" },
    { label: "hash_oaid", value: "__HASH_OAID__" },
    { label: "caid", value: "__QAID_CAA__" },
    { label: "adgroup_name", value: "__ADGROUP_NAME__" },
    { label: "site_set_name", value: "__SITE_SET_NAME__" },
    { label: "campaign_name", value: "__CAMPAIGN_NAME__" },
    { label: "ad_name", value: "__AD_NAME__" },
    { label: "model", value: "__MODEL__" },
    { label: "boost_exp_info", value: "__BOOST_EXP_INFO__" },
    { label: "boost_model_id", value: "__BOOST_MODEL_ID__" },
  ],
  //快手
  3: [
    { label: "dbt_accountid", value: "__ACCOUNTID__" },
    { label: "dbt_aid", value: "__AID__" },
    { label: "dbt_cid", value: "__CID__" },
    { label: "dbt_did", value: "__DID__" },
    { label: "dbt_dname", value: "__DNAME__" },
    { label: "dbt_imei2", value: "__IMEI2__" },
    { label: "dbt_imei3", value: "__IMEI3__" },
    { label: "dbt_oaid", value: "__OAID__" },
    { label: "dbt_oaid2", value: "__OAID2__" },
    { label: "dbt_idfa2", value: "__IDFA2__" },
    { label: "dbt_idfa3", value: "__IDFA3__" },
    { label: "dbt_mac2", value: "__MAC2__" },
    { label: "dbt_mac3", value: "__MAC3__" },
    { label: "dbt_androidid2", value: "__ANDROIDID2__" },
    { label: "dbt_androidid3", value: "__ANDROIDID3__" },
    { label: "dbt_os", value: "__OS__" },
    { label: "dbt_ts", value: "__TS__" },
    { label: "dbt_ip", value: "__IP__" },
    { label: "dbt_ua", value: "__UA__" },
    { label: "dbt_csite", value: "__CSITE__" },
    { label: "dbt_callback", value: "__CALLBACK__" },
    { label: "dbt_model", value: "__MODEL__" },
    { label: "dbt_ac_creative", value: "__AC_CREATIVE__" },
  ],
  // 星图
  4: [
    { label: "os", value: "__OS__" },
    { label: "ua", value: "__UA__" },
    { label: "ip", value: "__IP__" },
    { label: "model", value: "__MODEL__" },
    { label: "demand_id", value: "__DEMAND_ID__" },
    { label: "order_id", value: "__ORDER_ID__" },
    { label: "item_id", value: "__ITEM_ID__" },
    { label: "callback_param", value: "__CALLBACK_PARAM__" },
    { label: "callback_url", value: "__CALLBACK_URL__" },
  ],
  // OPPO
  20: [
    { label: "request_id", value: "$req$" },
    { label: "ad_id", value: "$ad$" },
    { label: "ua", value: "$ua$" },
    { label: "lang", value: "$lan$" },
    { label: "imei_md5", value: "$im$" },
    { label: "oaid", value: "__OAID__" },
  ],
};

export const callbackOptionConf = [
  "af_level_achieved",
  "af_purchase",
  "day_1_start",
  "day_2_start",
  "day_3_start",
  "day_4_start",
  "day_5_start",
  "day_6_start",
  "day_7_start",
  "inters_click_level_1",
  "inters_click_level_2",
  "inters_click_level_3",
  "inters_click_level_4",
  "inters_click_level_5",
  "inters_click_level_6",
  "inters_click_level_7",
  "inters_show_level_1",
  "inters_show_level_10",
  "inters_show_level_2",
  "inters_show_level_3",
  "inters_show_level_4",
  "inters_show_level_5",
  "inters_show_level_6",
  "inters_show_level_7",
  "inters_show_level_8",
  "inters_show_level_9",
  "inters_show_plus_level_1",
  "inters_show_plus_level_10",
  "inters_show_plus_level_11",
  "inters_show_plus_level_12",
  "inters_show_plus_level_13",
  "inters_show_plus_level_14",
  "inters_show_plus_level_15",
  "inters_show_plus_level_16",
  "inters_show_plus_level_17",
  "inters_show_plus_level_18",
  "inters_show_plus_level_19",
  "inters_show_plus_level_2",
  "inters_show_plus_level_20",
  "inters_show_plus_level_3",
  "inters_show_plus_level_4",
  "inters_show_plus_level_5",
  "inters_show_plus_level_6",
  "inters_show_plus_level_7",
  "inters_show_plus_level_8",
  "inters_show_plus_level_9",
  "t4_inters_show_plus_level_6",
  "t6_inters_show_plus_level_11",
  "time_level_1",
  "time_level_10",
  "time_level_11",
  "time_level_12",
  "time_level_13",
  "time_level_14",
  "time_level_15",
  "time_level_16",
  "time_level_17",
  "time_level_18",
  "time_level_2",
  "time_level_3",
  "time_level_4",
  "time_level_5",
  "time_level_6",
  "time_level_7",
  "time_level_8",
  "time_level_9",
  "video_click_level_1",
  "video_click_level_2",
  "video_click_level_3",
  "video_click_level_4",
  "video_click_level_5",
  "video_click_level_6",
  "video_click_level_7",
  "video_click_level_8",
  "video_click_level_9",
  "video_show_plus_level_1",
  "video_show_plus_level_10",
  "video_show_plus_level_11",
  "video_show_plus_level_12",
  "video_show_plus_level_13",
  "video_show_plus_level_14",
  "video_show_plus_level_15",
  "video_show_plus_level_16",
  "video_show_plus_level_17",
  "video_show_plus_level_18",
  "video_show_plus_level_19",
  "video_show_plus_level_2",
  "video_show_plus_level_20",
  "video_show_plus_level_3",
  "video_show_plus_level_4",
  "video_show_plus_level_5",
  "video_show_plus_level_6",
  "video_show_plus_level_7",
  "video_show_plus_level_8",
  "video_show_plus_level_9",
];
